import _get from 'lodash/get';
import env from '../../context/environment/initial';

export const isDisplayFeature = (key: string) => _get(env, `${key}`, 'false').toLowerCase() === 'false';
